import {withFormik} from 'formik'
import {navigate} from 'gatsby'
import qs from 'query-string'
import {flowRight} from 'lodash-es'

import AdvancedSearchComponent from './AdvancedSearch.component'
import {withHooks} from '~/hocs'
import useHooks from './AdvancedSearch.hooks'

const AdvancedSearchContainer = flowRight(
  withFormik({
    mapPropsToValues: ({initialValues}) => ({
      category: '',
      district: '',
      ward: '',
      street: '',
      direction: '',
      keyword: '',
      minPrice: '',
      maxPrice: '',
      minArea: '',
      maxArea: '',
      ...initialValues,
    }),
    handleSubmit: (values) => {
      const query = {}
      Object.entries(values).forEach(([key, value]) => {
        if (value) query[key] = value
      })
      const queryString = qs.stringify({
        ...query,
        page: 1,
      })

      navigate(`/search?${queryString}`)
    },
    enableReinitialize: true,
  }),
  withHooks(useHooks),
)(AdvancedSearchComponent)

export default AdvancedSearchContainer
